import { number, object } from "superstruct";

export const ReviewsSummarySchema = object({
    count: number(),
    avgRate: number(),
});
